import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UserOnboardingService } from '@app/modules/user-onboarding/services';
import { faFileUpload, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FilePondOptions } from 'filepond';
import { ToastrService } from 'ngx-toastr';
import { Observable, forkJoin, tap } from 'rxjs';

@Component({
  selector: 'mnf-modal-upload-ine',
  templateUrl: './modal-upload-ine.component.html',
  styleUrls: ['./modal-upload-ine.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalUploadIneComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    private onBoardServ: UserOnboardingService,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<ModalUploadIneComponent>
  ) { }

  /** Iconos */
  iconReUpload = faFileUpload;
  iconX = faXmark;

  @ViewChild('pondIdCardFront') pondIdCardFront: any;
  @ViewChild('pondIdCardBack') pondIdCardBack: any;
  @ViewChild('pondOther') pondOther: any;

  /** Definir archivos para subir INE Frontal */
  idCardFrontDefined: string;
  idCardFrontFile: string;
  idCardFrontTmpFile: File;
  idCardFrontName = '';

  /** Definir archivos para subir INE Reves */
  idCardBackDefined: string;
  idCardBackFile: string;
  idCardBackTmpFile: File;
  idCardBackName = '';

  /** Definir archivos para subir otros documentos */
  otherDefined: string;
  otherFile: string;
  otherTmpFile: File;
  otherName = '';

  /** Formato de archivo a aceptar */
  acceptableFiles = [
     'image/png',
     'image/jpeg',
     'application/pdf',
     'application/msword',
     'application/pdf',
     'application/xml',
     'image/webp',
     'application/zip',
     'application/x-zip-compressed'
  ];

  idCardFrontOptions: FilePondOptions = {
    labelIdle: '* Seleccionar fotografía<br> <strong>FRENTE INE</strong><br> (jpg, jpeg, png, etc.)',
    labelFileTypeNotAllowed: 'Tipo de archivo no válido',
    labelFileSizeNotAvailable: 'Tamaño máximo de 15 mb',
    /** 15 mb */
    chunkSize: 15728640,
    acceptedFileTypes: this.acceptableFiles
  };

  idCardBackOptions: FilePondOptions = {
    labelIdle: '* Seleccionar fotografía<br> <strong>REVERSO INE</strong><br> (jpg, jpeg, png, etc.)',
    labelFileTypeNotAllowed: 'Tipo de archivo no válido',
    labelFileSizeNotAvailable: 'Tamaño máximo de 15 mb',
    /** 15 mb */
    chunkSize: 15728640,
    acceptedFileTypes: this.acceptableFiles
  };

  otherOptions: FilePondOptions = {
    labelIdle: '* Seleccionar fotografía<br> <strong>IDENTIFICACIÓN OFICIAL</strong> <br>(jpg, jpeg, png, etc.)',
    labelFileTypeNotAllowed: 'Tipo de archivo no válido',
    labelFileSizeNotAvailable: 'Tamaño máximo de 15 mb',
    /** 15 mb */
    chunkSize: 15728640,
    acceptedFileTypes: this.acceptableFiles
  };

  idCardFrontFiles: FilePondOptions['files'] = [];
  idCardBackFiles: FilePondOptions['files'] = [];
  otherFiles: FilePondOptions['files'] = [];

  /** Tipo de respuesta select */
  optionsRadio = ['Si', 'No']
  /** Tipo de documento */
  optionsDocument = ['Seleccione', 'Pasaporte', 'Cedula profesional', 'Documento migratorio', 'Cartilla militar', 'INAPAM']
  /** Mostrar contenedor de INE*/
  ineShow: boolean = null;

  /** Formulario */
  formDocument: FormGroup;

  frontBeforeCompression: string;
  backBeforeCompression: string;

  uploadedFront: string;
  uploadedBack: string;
  uploadedOther: string;

  ngOnInit(): void {
    this.formDocument = this.fb.group({
      idCardFront: new FormControl(this.uploadedFront || this.idCardFrontDefined, Validators.compose([Validators.required])),
      idCardBack: new FormControl(this.uploadedBack || this.idCardBackDefined, Validators.compose([Validators.required])),
      otherDocument: new FormControl(this.otherDefined || ''),
      isINE: new FormControl(''),
      typeDocument: new FormControl(this.optionsDocument[0] || '', Validators.compose([Validators.required])),
   });
  }

  /** Función para cambiar el status del contenedor de documentos */
  changeDocumentType() {
    const formValue = this.formDocument.getRawValue();

    if(formValue.isINE === 'Si') {
      this.otherTmpFile = null;
      this.ineShow = true;
      // Revalidar formulario
      this.formDocument.get('idCardFront').setValidators([Validators.required]);
      this.formDocument.get('idCardBack').setValidators([Validators.required]);
      this.formDocument.get('otherDocument').setValidators([]);
      this.formDocument.get('typeDocument').setValidators([]);
    } else {
      this.idCardFrontTmpFile = null;
      this.idCardBackTmpFile = null;
       this.ineShow = false;
       // Revalidar formulario
       this.formDocument.get('idCardFront').setValidators([]);
       this.formDocument.get('idCardBack').setValidators([]);
       this.formDocument.get('otherDocument').setValidators([Validators.required]);
       this.formDocument.get('typeDocument').setValidators([Validators.required]);
    }
  }

  /** Función para subir archivo */
  pondHandleAddFile(event: any, type: 'idCardFront' | 'idCardBack' | 'otherDocument') {
    if(!event.error) {
       if(type === 'idCardFront') {
          const file = this.pondIdCardFront.getFile().file;
          this.idCardFrontTmpFile = file;
          // Asignar archivo al formilario
          this.formDocument.get(type).patchValue(event.file);
       }
       if(type === 'idCardBack') {
          const file = this.pondIdCardBack.getFile().file;
          this.idCardBackTmpFile = file;
          // Asignar archivo al formilario
          this.formDocument.get(type).patchValue(event.file);
       }
       if(type === 'otherDocument') {
          const file = this.pondOther.getFile().file;
          this.otherTmpFile = file;
          // Asignar archivo al formilario
          this.formDocument.get(type).patchValue(event.file);
       }
    }
  }

  /** Función para eliminar archivos encontrados */
  deleteFile(type: 'idCardFront' | 'idCardBack' | 'otherDocument') {
    if(type === 'idCardFront') {
       this.idCardFrontTmpFile = null;
       // Limpiar archivo
       this.formDocument.get(type).reset();
    }
    if(type === 'idCardBack') {
       this.idCardBackTmpFile = null;
       // Limpiar archivo
       this.formDocument.get(type).reset();
    }
    if(type === 'otherDocument') {
       this.otherTmpFile = null;
       // Limpiar archivo
       this.formDocument.get(type).reset();
    }
  }

  uploadDoc(){
    const form = this.formDocument.getRawValue();
    // Objeto a enviar
    const formToSend: any = {}
    // Request a realizar 
    const request: { [prop: string]: Observable<any> } = {};
    if(form.isINE === 'Si') {
       // Verificar si ya hay archivo adjuntado
       if(this.idCardFrontTmpFile) {
          // Subir INE Frontal en caso de que no sea null
          request.idCardFront = this.onBoardServ.uploadDocument(this.idCardFrontTmpFile, 'idCardFront').pipe(
             tap(
                res => {
                   this.idCardFrontFile = this.idCardFrontTmpFile.name;
                   if(res) {
                      this.toastr.success('Identificación oficial subida correctamente');
                   }
                },
             )
          );
       }
       // Verificar si ya hay archivo adjuntado
       if(this.idCardBackTmpFile) {
          // Subir INE Reverso en caso de que no sea null
          request.idCardBack = this.onBoardServ.uploadDocument(this.idCardBackTmpFile, 'idCardBack').pipe(
             tap(res => {
                this.idCardBackFile = this.idCardBackTmpFile.name;
             })
          );
       }
       formToSend.typeDocument = 'INE';
       request.info = this.onBoardServ.typeDocument(formToSend);
    } else {
       // Subir el documento adicional en caso de que no sea null
       if(this.otherTmpFile) {
          request.otherDocument = this.onBoardServ.uploadDocument(this.otherTmpFile, 'otherDocument').pipe(
             tap(res => {
                this.otherFile = this.otherTmpFile.name;
                if(res) {
                   this.toastr.success('Identificación oficial subida correctamente');
                }
             })
          );
       }
       // Asignar tipo de documento
       formToSend.typeDocument = form.typeDocument;
       
       if(form.typeDocument === 'Seleccione') {
          this.toastr.warning('Seleccione un tipo de documento');
          return;
       } {
          request.info = this.onBoardServ.typeDocument(formToSend);
       }
    }
    // Subir archivos por multiple petición
    forkJoin(request).subscribe((res) => {
       if(res) {
          this.toastr.success('Tus documentos se han actualizado correctamente');
          this.dialogRef.close(true);
       } else {
          this.toastr.warning('Se encontraron problemas al subir los archivos');
          this.dialogRef.close(true);
       }
    })
  }

  /** Función para validar documento */
  validateDocument(): boolean {

    const form = this.formDocument.getRawValue();

    if(form.isINE == 'Si' || form.isINE == '') {
      if(this.idCardFrontTmpFile == undefined || this.idCardBackTmpFile == undefined) {
        return true;
      }
    } else if (form.isINE == 'No') {
      if(this.otherTmpFile == undefined) {
        return true;
      }
    }
        
    return false;
  }


  close() {
    this.dialogRef.close();
  }


}
